import { render } from "./TalkRoomMoreButton.vue?vue&type=template&id=3c1a78bc&ts=true"
import script from "./TalkRoomMoreButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./TalkRoomMoreButton.vue?vue&type=script&lang=ts&setup=true"

import "./TalkRoomMoreButton.vue?vue&type=style&index=0&id=3c1a78bc&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/communityTalk/talkRoom/TalkRoomMoreButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c1a78bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c1a78bc', __exports__)) {
    api.reload('3c1a78bc', __exports__)
  }
  
  module.hot.accept("./TalkRoomMoreButton.vue?vue&type=template&id=3c1a78bc&ts=true", () => {
    api.rerender('3c1a78bc', render)
  })

}


export default __exports__